





















import Vue from 'vue'

export interface Option {
  label: string
  value: string | number
}

export type Options = Option[]

export default Vue.extend({
  name: 'OptionList',
  filters: {
    toIconName(checked: boolean): string {
      return checked ? 'checkbox' : 'checkbox_null'
    },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Array as () => Options,
      default: () => [],
    },
    values: {
      type: Array as () => Option['value'][],
      default: () => [],
    },
    isOptionsFullWidth: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(value: Option['value']) {
      this.$emit(
        'change',
        this.values.includes(value)
          ? this.values.filter((v) => v !== value)
          : [...this.values, value]
      )
    },
  },
})
